module.exports = __webpack_public_path__ + "img/new_img.b1660910.png";